<div
  class="user-settings-drawer-details"
  (click)="$event.stopPropagation()"
  data-e2e="user-drawer-fragment"
>
  <header class="user-settings-drawer-details__header">
    <user-info
      class="user-settings-drawer-details__user-info"
      data-e2e="user-info-fragment"
    >
    </user-info>

    <span class="user-settings-drawer-details__header__actions">
      <vertical-divider></vertical-divider>
      <logout-button e2e="user-drawer-fragment"></logout-button>
    </span>
  </header>

  <section class="user-settings-drawer-details__help">
    <header class="user-settings-drawer-details__section-header">
      <h2>{{ "settings.help.title" | translate }}</h2>
      <mat-slide-toggle
        #helpModeToggle
        (change)="toggleHelpMode(helpModeToggle.checked)"
        [checked]="isHelpModeActive$ | async"
        data-e2e="user-drawer-fragment__help-switch-toggle"
      ></mat-slide-toggle>
    </header>
  </section>

  <section class="user-settings-drawer-details__user-profile-application">
    <header
      class="user-settings-drawer-details__section-header user-settings-drawer-details__link"
      data-e2e="user-drawer-fragment__user-profile-application"
      (click)="openUserProfileApplication()"
    >
      <h2>
        <app-svg-icon
          fill="drawer-button"
          icon="external_link"
          size="small"
          class="user-settings-drawer-details__link-icon"
        ></app-svg-icon
        >{{ "admin.settings.user_profile" | translate }}
      </h2>
    </header>
  </section>

  <section class="user-settings-drawer-details__user-management-application">
    <header
      class="user-settings-drawer-details__section-header user-settings-drawer-details__link"
      data-e2e="user-drawer-fragment__user-management-application"
      (click)="openUserManagement()"
    >
      <h2>
        <app-svg-icon
          icon="external_link"
          size="small"
          fill="drawer-button"
          class="user-settings-drawer-details__link-icon"
        ></app-svg-icon
        >{{ "admin.settings.manage_users" | translate }}
      </h2>
    </header>
  </section>
</div>
